const p = {
  "cdr-popup": "cdr-popup_16-2-1",
  "cdr-popup--open": "cdr-popup--open_16-2-1",
  "cdr-popup--closed": "cdr-popup--closed_16-2-1",
  "cdr-popup__content": "cdr-popup__content_16-2-1",
  "cdr-popup__arrow": "cdr-popup__arrow_16-2-1",
  "cdr-popup--top": "cdr-popup--top_16-2-1",
  "cdr-popup--bottom": "cdr-popup--bottom_16-2-1",
  "cdr-popup--exit": "cdr-popup--exit_16-2-1",
  "cdr-popup--corner-left": "cdr-popup--corner-left_16-2-1",
  "cdr-popup--corner-right": "cdr-popup--corner-right_16-2-1",
  "cdr-popup--left": "cdr-popup--left_16-2-1",
  "cdr-popup--right": "cdr-popup--right_16-2-1",
  "cdr-popup--corner-top": "cdr-popup--corner-top_16-2-1",
  "cdr-popup--corner-bottom": "cdr-popup--corner-bottom_16-2-1"
};
export {
  p as default
};
